/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div class="indexPage">
    <div class="indexSwiperBanner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(carouselItem, carouselIndex) in carouselList"
          :key="carouselIndex"
        >
          <div >  <!-- @click="linkUrl(carouselItem.url)" -->
            <img :src="carouselItem.pic" alt />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>-->
      </swiper>
    </div>
    <div class="goodsSortBox">
      <div
        class="goodsSortList"
        v-for="(sortNavItem, sortNavIndex) in sortList"
        :key="sortNavIndex"
      >
        <a @click="getOpt(sortNavItem)">
          <div class="imgBox">
            <img :src="$imgUrl.imgUrl(sortNavItem.image)" alt />
          </div>
          <div class="text">{{ sortNavItem.catname }}</div>
        </a>
      </div>
    </div>
    <div class="titleIndexBox">
      <div class="title">明星产品</div>
      <div class="subtitle">Bestseller</div>
    </div>
    <div class="indexBanner" @click="linkUrl(productUrl)">
      <img
        :src="productImg"
        alt
      />
    </div>
    <div class="productSwiper">
      <swiper :options="productOption" ref="productSwiper">
        <swiper-slide
          v-for="(productItem, productIndex) in productList"
          :key="productIndex"
        >
          <div class="productBox" @click="goProductDetail(productItem)">
            <img :src="productItem.thumb" alt mode="aspectFill" />
            <div class="name">{{ productItem.title }}</div>
            <div class="text">{{ productItem.keywords }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="swiper-button-next" slot="button-next">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="titleIndexBox Information">
      <div class="title">糠宝瑞资讯</div>
      <div class="subtitle">Daoxi Information</div>
    </div>
    <div class="daoxiInformation">
      <div class="infoBox">
        <div class="videoBox">
          <video
            :src="videoLink"
            id="whVideo"
            loop="loop"
            x5-video-player-type="h5-page"
            autoplay
            webkit-playsinline
            x5-playsinline
            playsinline
            muted
          >
            <source :src="videoLink" type="video/mp4" />
            <source :src="videoLink" type="video/webm" />
            <source :src="videoLink" type="video/ogg" />
          </video>
        </div>
        <div class="article">
          <div
            class="articleList"
            v-for="(articleItem, articleIndex) in articleList.slice(0, 2)"
            :key="articleIndex"
            @click="getNewsDetailUrl(articleItem)"
          >
            <div class="title textLinesLimit_1">{{ articleItem.title }}</div>
            <div class="content textLinesLimit_2">{{ articleItem.description }}</div>
          </div>
          <div class="articleBtn" @click="goInfomationUrl(articleList[0])">
            <div>了解更多</div>
            <div>
              <img alt />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
/* .indexPage{padding-top: 88px;} */
.indexSwiperBanner .swiper-container {
  height: 960px;
}
.indexSwiperBanner .swiper-container img {
  display: block;
  width: 100%;
  height: 100%;
}
/deep/.swiper-pagination .swiper-pagination-bullet {
  width: 14px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.75;
  border-radius: 50%;
}
/deep/.swiper-pagination .swiper-pagination-bullet-active {
  width: 40px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.5;
  border-radius: 7px;
}
/deep/.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 48px;
}
.productSwiper {
  /* min-width: 1300px; */
  display: flex;
  justify-content: center;
  position: relative;
  background: #f4f7f2;
  margin-top:30px;
}
.productSwiper .swiper-container {
  height: 494px;
  width: 75vw;
  min-width: 975px;
}
.productSwiper .productBox {
  width: 280px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
.productSwiper .productBox .name {
  margin-top: 40px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
}
.productSwiper .productBox .text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 42px;
}
.productSwiper img {
  width: 100%;
  height: 280px;
}
.productSwiper .productBox:hover {
  width: 336px;
}
.productSwiper .productBox:hover img {
  height: 336px;
}
.productSwiper .productBox:hover .name,
.productSwiper .productBox:hover .text {
  width: 336px;
}
.productSwiper .swiper-slide {
  display: flex;
  align-items: center;
}
/deep/.productSwiper .swiper-button-prev,
.productSwiper .swiper-container-rtl .swiper-button-next {
  left: 8vw;
  background-image: initial;
  width: 54px;
  height: 54px;
  background: #ffffff;
  border-radius: 50%;
  line-height: 54px;
  text-align: center;
  font-size: 26px;
}
/deep/.productSwiper .swiper-button-next,
.productSwiper .swiper-container-rtl .swiper-button-prev {
  right: 8vw;
  background-image: initial;
  width: 54px;
  height: 54px;
  background: #ffffff;
  border-radius: 50%;
  line-height: 54px;
  text-align: center;
  font-size: 26px;
}
/deep/.productSwiper .swiper-button-prev,
.productSwiper .swiper-button-next:focus {
  outline: none;
}
.goodsSortBox {
  height: 389px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.goodsSortList {
  width: 272px;
  position: relative;
}
.goodsSortList::after {
  content: "";
  position: absolute;
  top: 14px;
  right: 0;
  height: 54px;
  width: 3px;
  background-color: #cde9da;
}
.goodsSortList:last-child::after {
  width: 0;
}
.goodsSortList a {
  text-decoration: none;
  display: block;
  transition: all 0.3s;
  text-align: center;
}
.goodsSortList a .imgBox {
  width: 134px;
  height: 90px;
  /* background: #e5e5e5; */
  border-radius: 10px;
  margin: 0 auto;
}
.goodsSortList a img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.goodsSortList a .text {
  font-size: 18px;
  font-weight: 400;
  color: #009144;
  line-height: 42px;
  margin-top: 24px;
}
.goodsSortList a img[src=""],
.goodsSortList a img:not([src]) {
  opacity: 0;
  border: none;
  visibility: hidden;
  max-width: none;
}
.goodsSortList a:hover {
  transform: translateY(-8px);
}
.titleIndexBox {
  text-align: center;
  margin-bottom: 46px;
}
.titleIndexBox .title {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #009144;
}
.titleIndexBox .subtitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 42px;
}
.Information {
  margin-top: 120px;
}
.indexBanner{
  line-height: 0;
}
.indexBanner img {
  width: 100%;
  height: 1080px;
}
.daoxiInformation {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 90px;
}
.daoxiInformation .infoBox {
  display: flex;
  width: 1600px;
}
.daoxiInformation .infoBox .videoBox {
  width: 700px;
  height: 380px;
}
.daoxiInformation .infoBox .videoBox video {
  height: 100%;
}
.daoxiInformation .infoBox .article {
  flex: 1;
  padding: 16px 50px;
  box-sizing: border-box;
  position: relative;
}
.daoxiInformation .infoBox .article .articleList {
  margin-bottom: 42px;
  cursor: pointer;
}
.daoxiInformation .infoBox .article .articleList .title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #212121;
  line-height: 42px;
}
.daoxiInformation .infoBox .article .articleList .content {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin-top: 3px;
}
/deep/.daoxiInformation .infoBox .article .articleList .title:hover,.daoxiInformation .infoBox .article .articleList .content:hover{
  color: #009144;
}
.articleBtn {
  position: absolute;
  bottom: 16px;
  right: 50px;
  display: flex;
  align-items: center;
  width: 124px;
  height: 38px;
  padding: 11px 14px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
}
.articleBtn div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.articleBtn img {
  margin-left: 8px;
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_gray.png);
}
.articleBtn:hover {
  background: #009144;
}
.articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
}
.homeBannerGo button,
.homeExperienceGO button {
  background: none;
  border: 1px solid #267fe9;
  color: #267fe9;
  font-size: 18px;
  font-weight: 400;
  font-style: italic;
}
video {
  width: 100%;
  object-fit: fill;
}
.homeProduct .arrow-right {
  display: none;
  width: 27px;
  height: 7px;
  background: url(../../src/img/arrow_right.png) no-repeat;
  background-size: 100% 100%;
}
.test-enter,
.test-leave-to {
  opacity: 0;
}
.test-enter-to,
.test-leave {
  opacity: 1;
}
.test-enter-active,
.test-leave-active {
  transition: all 5s;
}
.homeExperience span {
  position: relative;
  overflow: hidden;
  width: 542px;
  height: 480px;
}
.homeExperienceImg {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {
      //轮播图
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // }
      },
      productOption: {
        loop: true,
        loopedSlides: 3,
        // slidesPerView: 'auto',
        slidesPerView: 3, //页面分组显示，这里显示为3组
        // slidesPerGroup: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      carouselList: [

      ],
      productList: [

      ],
      //类目选择
      sortList: [

      ],
      articleList: [

      ],
      // 页头当前
      sort: "0",
      mark: 0,
      description: "",
      product: [],
      // 产品介绍导航
      goodsList: [],
      videoLink:'',
      productImg:'',
      productUrl:'',
    };
  },
  created() {
    if (document.documentElement.clientWidth < 980) {
      window.location.href = "https://wap.hengliannet.com";
    }
    this.getnewList();
    // this.play();
  },
  methods: {
    //跳转
    linkUrl(url) {
      if(url.indexOf('http')!=-1){
        window.location.href = url;
      }else{
        this.$router.push(url);
      }
    },
    //跳转到产品详情
    goProductDetail(item) {
      this.$router.push({ name: "productDetail", query: {id:item.id,catid:item.catid} });
    },
    getnewList() {
      axios.post("/api/index/index").then((res) => {
        this.carouselList=res.data.banner
        for (var i in this.carouselList) {
          this.carouselList[i].pic = imgUrl.imgUrl(this.carouselList[i].pic);
        }
        this.videoLink=imgUrl.imgUrl(res.data.video);
        this.productUrl=res.data.product.banner[0].url
        this.productImg=imgUrl.imgUrl(res.data.product.banner[0].pic);
        var productList=res.data.product.list;
        for (var i in productList) {
          productList[i].thumb = imgUrl.imgUrl(productList[i].thumb);
        }
        this.productList=productList;
        var news=res.data.news;
        for (var i in news) {
          news[i].thumb = imgUrl.imgUrl(news[i].thumb);
        }
        this.articleList=news;
        var category=res.data.product.category;
        // for (var i in category) {
        //   category[i].thumb = imgUrl.imgUrl(category[i].thumb);
        // }
        this.sortList=category;
      });
    },
    // getOpt(link){
		// 	let path=link
		// 	this.$router.push(path)
    // },
    getOpt(item){
			let path=''
			if(item.url.indexOf('?')!=-1){
				path=item.url+'&id='+item.id
				this.$router.push(path)
			}else{
				path=item.url
				this.$router.push({path: path,query: {id:item.id}});
			}
		},
    goInfomationUrl(item) {
      this.$router.push({path: "/infomation",query: {id:item.catid}});
    },
    getNewsDetailUrl(item){
      this.$router.push({ name: "newListDetail", query: {id:item.id,catid:item.catid}});
    },
    getProductUrl() {
      this.$router.push({
        path: "/product",
        query: { activeNum: this.sort, activeName: this.tabNum },
      });
    },
  },
};
</script>

